/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import TextIconInformationBox from '@components/Onboarding/TextIconInformationBox';
import { TextIconBoxType } from '@components/Onboarding/constants';
import React from 'react';

const MobileConfirmationDialog = ({
  icon,
  isShown,
  description,
  close,
  buttons,
  textIconBoxType = undefined
}) => {
  return (
    <>
      {isShown && (
        <div
          className="fixed inset-0 z-[1250] bg-black/70 flex items-end justify-center p-8"
          onClick={close}>
          <div
            className="bg-white z-[1300] flex-1 h-[246px] min-h-[246px] flex flex-col items-center pt-6 px-4 pb-1 rounded-3xl shadow-xl sm:max-w-[400px] sm:m-auto"
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
            }}>
            {textIconBoxType ? (
              <div className="mb-[18px] flex-1">
                <TextIconInformationBox
                  card={TextIconBoxType[textIconBoxType]}
                  noBackgroundCircle={true}
                />
              </div>
            ) : (
              <>
                <div className="bg-white flex w-[58px] h-[58px] justify-center items-center rounded-full shadow-md">
                  {icon}
                </div>
                <div className="mt-4 text-xs text-slate-600 text-center flex-1">{description}</div>
              </>
            )}
            <div className="flex flex-col w-full">
              {buttons.map(button => {
                return button;
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileConfirmationDialog;
